import { useEffect, useState } from "react"

import { useLazyGetOrderStatusesQuery } from "store/api/widgetsApi"

import { WidgetVendorOrderStatusContent } from "components/widgets/WidgetVendorOrderStatus/WidgetVendorOrderStatusContent"

const initialState = {
  new: 0,
  confirmed: 0,
  packed: 0,
  shipping: 0,
  fulfilled: 0,
  denied: 0,
  total: 0,
}

export const WidgetContractorOrderStatus = () => {
  const [triggerGetOrderStatuses, { isFetching }] = useLazyGetOrderStatusesQuery()
  const [widgetData, setWidgetData] = useState(initialState)

  useEffect(() => {
    const fetchData = async () => {
      const res = await triggerGetOrderStatuses()
      if (res?.data?.data) {
        const d = res.data.data
        setWidgetData({
          new: d.new ?? 0,
          confirmed: d.confirmed ?? 0,
          packed: d.packed ?? 0,
          shipping: d.shipping ?? 0,
          fulfilled: d.fulfilled ?? 0,
          denied: d.denied ?? 0,
          total: d.total ?? 0,
        })
      }
    }

    fetchData()
  }, [triggerGetOrderStatuses])

  return <WidgetVendorOrderStatusContent data={widgetData} isLoading={isFetching} />
}
